import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/*助力红包浮窗组件
 * <component-redpack-float :visible.sync="xx"></component-redpack-float>
 */
import { isIos } from '@ykz/ykz-util/platform';
import { ex_getYCFLocInfo } from "../../util/location";
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'redpackFloat',
  data: function data() {
    return {
      loadActivityExplanation: false,
      //加载活动说明弹框
      showActivityExplanation: false,
      //显示活动说明弹框
      showOutAnimation: false,
      //展示关闭弹框动画

      goodId: getUrlParams('goodId') || '',
      //商品id
      orderNo: getUrlParams('orderNo') || '',
      //订单号

      redpackInfo: {},
      //助力红包信息
      isIos: isIos() //判断设备系统是否属于ios
    };
  },

  props: ['isShow', 'redpack', 'price', 'isPromoter'],
  watch: {
    showActivityExplanation: function showActivityExplanation(val) {
      if (val) {
        $('.component-redpack-float').css('z-index', 2000);
      } else {
        $('.component-redpack-float').css('z-index', 1999);
      }
    }
  },
  computed: {
    //计算返现的红包数
    getReturnRedpack: function getReturnRedpack() {
      var redpackNum = Math.round((this.price || 0) * (this.redpackInfo.goodRatio || 0) * 100) / 100;
      if (redpackNum > this.redpackInfo.redPackageMoneyMax) {
        redpackNum = this.redpackInfo.redPackageMoneyMax; //返现红包的上限
      }

      this.$emit('update:redpack', redpackNum);
      return redpackNum;
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.redpackFloat = this;
    console.log('ycf组件初始化：redpackFloat');
    !this.orderNo && this.getRedPackageGoodConf();
  },
  methods: {
    //显示或隐藏红包文案浮条
    switchFloatStrip: function switchFloatStrip(showFloatStrip) {
      this.switchTimeout && clearTimeout(this.switchTimeout);
      if (showFloatStrip) {
        $('.component-redpack-float .float-strip').css('width', $('.component-redpack-float .float-strip .transition-content').innerWidth());
      } else {
        $('.component-redpack-float .float-strip').css('width', 0);
      }
    },
    //显示活动说明弹框
    showActivityBox: function showActivityBox() {
      if (this.loadActivityExplanation) {
        this.showActivityExplanation = true;
      } else {
        this.loadActivityExplanation = true;
        this.$nextTick(function () {
          this.showActivityExplanation = true;
          $('.activity-explanation .text-scroll').scroll(function () {
            if (this.scrollTop + this.offsetHeight >= this.scrollHeight) {
              $('.activity-explanation .text-content>img').css('display', 'none');
            } else {
              $('.activity-explanation .text-content>img').css('display', 'inline-block');
            }
          });
        });
      }
    },
    //隐藏弹框
    hideBox: function hideBox() {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        that.showActivityExplanation = false;
      }, 200);
    },
    //获取助力红包配置属性
    getRedPackageGoodConf: function getRedPackageGoodConf() {
      var that = this;
      //  获取位置信息
      ex_getYCFLocInfo().then(function (res) {
        databus({
          url: '/api/yuncoin/getRedPackageGoodConf',
          type: 'post',
          origin: Origins.API_ACT,
          data: {
            goodId: this.goodId,
            province: res.province,
            city: res.city,
            district: res.district,
            longitude: res.longitude,
            latitude: res.latitude
          },
          success: function success(res) {
            if (res.code == 1000 && res.bcode == 100) {
              that.redpackInfo = res.content || {};
              if (that.redpackInfo.isShow && that.redpackInfo.goodRatio && !that.redpackInfo.isPromoterInBlack) {
                that.$emit('update:isShow', true);
                that.$nextTick(function () {
                  setTimeout(function () {
                    that.switchFloatStrip(true);
                    that.switchTimeout = setTimeout(function () {
                      that.switchFloatStrip(false);
                    }, 3000);
                  }, 500);
                });
              }
            }
          }
        });
      });
    }
  }
};